exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-table-expand[data-v-222ae298]{font-size:0;padding:0 40px}.demo-table-expand label[data-v-222ae298]{width:90px;color:#99a9bf}.demo-table-expand .el-form-item[data-v-222ae298]{margin-right:0;margin-bottom:0;width:50%}", ""]);

// exports
